var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"value":_vm.isShow,"color":"warning","outline":""}},[_c('div',[_c('i18n',{attrs:{"path":"noCreditCardSupport","tag":"div"},scopedSlots:_vm._u([{key:"method",fn:function(){return [_c('a',{attrs:{"href":_vm.otherPaymentMethodLink,"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('otherPaymentMethod')))])]},proxy:true}])})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }